export default __webpack_public_path__ + "static/media/my_portfolio.4b69a571.png";